var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c(
        "div",
        { staticClass: "p-10 bg-white" },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.list,
                stripe: "",
                "highlight-current-row": "",
                "row-style": _vm.tableStyle,
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "标题", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.mould_name) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "使用详情" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.mould_desc) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "关键词" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(scope.row.filed_data, function (item) {
                        return _c("span", [
                          _vm._v(_vm._s(item.field_title) + "，"),
                        ])
                      })
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "模板ID" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.template_id) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "appid" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.appid) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "类型", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.type == 0
                                ? "一次性订阅"
                                : scope.row.type == 1
                                ? "公众号模板消息"
                                : ""
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              round: "",
                              plain: "",
                            },
                            on: {
                              click: function ($event) {
                                _vm.tempDialog = true
                                _vm.tempInfo = scope.row
                                _vm.appid = scope.row.appid
                                _vm.template_id = scope.row.template_id
                              },
                            },
                          },
                          [_vm._v("设置")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "模板消息", visible: _vm.tempDialog },
          on: {
            "update:visible": function ($event) {
              _vm.tempDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "auto" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.tempInfo.mould_name + "模板ID：" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.template_id,
                      callback: function ($$v) {
                        _vm.template_id = $$v
                      },
                      expression: "template_id",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.tempInfo.mould_name + "appid：" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.appid,
                      callback: function ($$v) {
                        _vm.appid = $$v
                      },
                      expression: "appid",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.tempDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.editID()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }